<template>
  <div id="app">
    <Header></Header>
    <keep-alive>
      <router-view :class="classObj" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :class="classObj" v-if="!$route.meta.keepAlive"></router-view>
    <Footer></Footer>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "App",
  data() {
    return {
      classObj: ["content_width", "main_content"],
    };
  },
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue